import { del, get, post } from '../client';

export const indentsApi = {
  list: (params) => get('/indents', { params }),
  pendingCount: () => get('/indents/pending-count'),
  getById: (id) => get(`/indents/${id}`),
  create: (body) => post('/indents', body),
  recommend: (id, body) => post(`/indents/${id}/recommend`, body),
  assign: (id, body) => post(`/indents/${id}/assign`, body),
  release: (id, body) => post(`/indents/${id}/release`, body),
  cancel: (id) => post(`/indents/${id}/cancel`),
  remove: (id) => del(`/indents/${id}`),
};
